/**
 * @generated SignedSource<<453bace08de93d3f1a281c5665498edc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeletePersonalizedNotificationTemplateInput = {
  clientMutationId?: string | null | undefined;
  ids: ReadonlyArray<string>;
};
export type NotificationTemplatesTable_DeleteMutation$variables = {
  connections: ReadonlyArray<string>;
  input: DeletePersonalizedNotificationTemplateInput;
};
export type NotificationTemplatesTable_DeleteMutation$data = {
  readonly Admin: {
    readonly Notification: {
      readonly deletePersonalizedNotificationTemplate: {
        readonly deletedIds: ReadonlyArray<string>;
      } | null | undefined;
    };
  };
};
export type NotificationTemplatesTable_DeleteMutation = {
  response: NotificationTemplatesTable_DeleteMutation$data;
  variables: NotificationTemplatesTable_DeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedIds",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationTemplatesTable_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Notification",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "DeletePersonalizedNotificationTemplatePayload",
                "kind": "LinkedField",
                "name": "deletePersonalizedNotificationTemplate",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "NotificationTemplatesTable_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Notification",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "DeletePersonalizedNotificationTemplatePayload",
                "kind": "LinkedField",
                "name": "deletePersonalizedNotificationTemplate",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "deleteEdge",
                    "key": "",
                    "kind": "ScalarHandle",
                    "name": "deletedIds",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "connections"
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4da63d32baf953b9ce29ea0da37f50f2",
    "id": null,
    "metadata": {},
    "name": "NotificationTemplatesTable_DeleteMutation",
    "operationKind": "mutation",
    "text": "mutation NotificationTemplatesTable_DeleteMutation(\n  $input: DeletePersonalizedNotificationTemplateInput!\n) {\n  Admin {\n    Notification {\n      deletePersonalizedNotificationTemplate(input: $input) {\n        deletedIds\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1663614fbe116d8f9545c671ced60ce0";

export default node;
